import { Avatar, Box, HStack, StackProps, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useGetUserLoginStore } from "../../store/useGetUserLoginStore";
import { useUserHeader } from "../../store/useUserHeader";

interface Props extends StackProps {}

export const UserHeaderCard = ({ ...rest }: Props) => {
  const { userHeader, fetchUserHeader } = useUserHeader();
  const { currentActiveUser } = useGetUserLoginStore();

  useEffect(() => {
    if (!userHeader || currentActiveUser?.role !== userHeader?.role) {
      fetchUserHeader(currentActiveUser?.id, `${currentActiveUser?.role}`);
    }
  }, []);

  return (
    <HStack
      display={{ base: "none", lg: "flex" }}
      alignItems="center"
      cursor={"pointer"}
      {...rest}
    >
      <Box textAlign={"right"}>
        <Text textStyle={"b-reg-sb"} maxWidth="12ch" noOfLines={1}>
          {userHeader?.name}
        </Text>
        <Text textStyle={"b-sm-sb"} fontWeight={500} variant={"secondary"}>
          Akun&nbsp;
          {currentActiveUser?.role === "buyer"
            ? "Pembeli"
            : currentActiveUser?.role === "supplier"
            ? "Supplier"
            : currentActiveUser?.role === "reseller"
            ? "Reseller"
            : "BisnisLink"}
        </Text>
      </Box>

      <Avatar
        name={userHeader?.name || ""}
        color={"red.400"}
        src={
          userHeader?.image
            ? `${process.env.REACT_APP_MEDIA_URL}${userHeader?.image}`
            : ""
        }
        objectFit={"cover"}
        ml={"4px"}
      />
    </HStack>
  );
};
